<template>
  <div class="row row-equal">
    <div class="flex xl8 xs12">
      <div class="row">
        <div class="flex xs12 sm4">
          <va-card class="mb-4" color="info">
            <p class="display-2 mb-0" style="color: white; font-size: 28px;">{{ deposit | Currency }}</p>
            <p>{{$t('dashboard.info.deposit-contribution')}}</p>
          </va-card>
        </div>

        <div class="flex xs12 sm4">
          <va-card class="mb-4" color="danger">
            <p class="display-2 mb-0" style="color: white; font-size: 28px;">{{ share | Currency }}</p>
            <p>{{$t('dashboard.info.share-capital')}}</p>
          </va-card>
        </div>

        <div class="flex xs12 sm4">
          <va-card class="mb-4" color="warning">
            <p class="display-2 mb-0" style="color: white; font-size: 28px;">{{ loan | Currency }}</p>
            <p>{{$t('dashboard.info.outstanging-loans')}}</p>
          </va-card>
        </div>

      </div>

      <!-- <div class="row">
        <div class="flex xs12 md4">
          <va-card>
            <p class="display-2 mb-1" :style="{color: color_1}">{{ fosa_bal | Currency }}</p>
            <p class="no-wrap">{{$t('dashboard.info.totalFosaBalance')}}</p>
          </va-card>
        </div>
        <div class="flex xs12 md8">
          <va-card>
            <div class="row row-separated">
              <div class="flex xs6 md4" v-for="(fosa, idx) in fosas" :key="idx">
                <p class="display-3 mb-2 text--center" :style="dynamicStyle(idx)">{{ fosa.balance | Currency }}</p>
                <p class="text--center mb-2">{{ fosa.accname }}</p>
              </div>
            </div>
          </va-card>
        </div>
      </div> -->
    </div>

    <div class="flex xs12 md12 xl4">
      <va-card
        stripe="info"
        :title="$t('dashboard.info.latest-notification')"
      >
        {{ latest_notfication?.message }}

        <va-item-label caption>
          {{ latest_notfication.date_sent | formatDate }} {{ latest_notfication.time_sent }}
        </va-item-label>

        <div class="row mt-3">
          <va-button color="primary"  @click="viewall">
            {{$t('dashboard.info.view-all')}}
          </va-button>
        </div>
      </va-card>
    </div>
    <va-modal
      v-model="showModal"
      position="top"
      size = "large"
      :fullscreen = "fullscreen"
      :mobileFullscreen = "fullscreenmobile"
      :title=" $t('notifications')"
      cancelClass="none"      
      :okText=" $t('modal.close') "     
      :cancelText=" $t('modal.cancel')"      
    >
      <template v-for="(notification, i) in notifications">
        <va-item>
          <va-item-section avatar>
            <avatar :username="tostring(i+1)" :color="spinnersColor"></avatar>
          </va-item-section>
          <va-item-section>            
              {{ notification.message }}           

            <va-item-label caption>
              {{ notification.date_sent | formatDate }} {{ notification.time_sent }}
            </va-item-label>      

          </va-item-section>    
        </va-item>
      </template>
    </va-modal>
  </div>
</template>

<script>
import axios from 'axios'
import Avatar from 'vue-avatar'

export default {
  name: 'DashboardInfoBlock',
  components: {
    Avatar,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')) || {},
      token: JSON.parse(localStorage.getItem('Token')) || '',
      latest_notfication: {},
      notifications: [],
      fosas: [],
      showModal: false,
      fullscreen: false,
      fullscreenmobile: true,
      spinnersColor: '#537c3d',

      // Dashboard values
      share: 0,
      deposit: 0,
      loan: 0,
      fosa_bal: 0,

      // Theme colors
      color_: 'color_',
      color_0: this.$themes.primary,
      color_1: this.$themes.info,
      color_2: this.$themes.success,
      color_3: this.$themes.danger,
      color_4: this.$themes.warning,
    }
  },

  methods: {
    // Reusable auth header config
    getConfig() {
      return {
        headers: {
          Authorization: `${this.userData.user_id} ${this.token}`,
        },
      }
    },

    tostring(val) {
      return val?.toString()
    },

    dynamicStyle(numb) {
      const colors = [
        this.color_0,
        this.color_1,
        this.color_2,
        this.color_3,
        this.color_4,
      ]
      return {
        color: colors[numb] || this.color_1,
        fontSize: '20px',
      }
    },

    async getLoans() {
      try {
        const { data } = await axios.post(`${this.$apiUrl}GetTotalOutStandingLoans`, this.userData.user_id, this.getConfig())
        this.loan = data?.amount ?? 0
      } catch (error) {
        console.error('Loan fetch error:', error)
      }
    },

    async getDeposit() {
  try {
    const { data } = await axios.post(
      `${this.$apiUrl}GetBackOfficeAccounts`,
      this.userData.user_id,
      this.getConfig()
    )

    if (Array.isArray(data)) {
      const shareAcc = data.find(acc => acc.accname === 'Share Capital')
      const depositAcc = data.find(acc => acc.accname === 'Deposit Contribution')

      this.share = shareAcc ? Number(shareAcc.balance) : 0
      this.deposit = depositAcc ? Number(depositAcc.balance) : 0
    } else {
      this.share = 0
      this.deposit = 0
    }
  } catch (error) {
    console.error('Deposit fetch error:', error)
  }
},


    // async getShare() {
    //   try {
    //     const posdata = { user: this.userData.user_id}
    //     const { data } = await axios.post(`${this.$apiUrl}GetBackOfficeAccounts`, this.userData.user_id, this.getConfig())
    //     this.share = data?.acc_balance ?? 0
    //   } catch (error) {
    //     console.error('Share fetch error:', error)
    //   }
    // },

    async getLoans() {
      try {
        const { data } = await axios.post(`${this.$apiUrl}GetTotalOutStandingLoans`, this.userData.user_id, this.getConfig())
        this.loan = data?.amount ?? 0
      } catch (error) {
        console.error('Loan fetch error:', error)
      }
    },

    async getFosaBal() {
      try {
        const { data } = await axios.post(`${this.$apiUrl}GetAllFosaBalance`, this.userData.user_id, this.getConfig())
        this.fosa_bal = data?.amount ?? 0
      } catch (error) {
        console.error('Fosa balance fetch error:', error)
      }
    },

    async getFosaAccs() {
      try {
        const { data } = await axios.post(`${this.$apiUrl}GetFosaAccounts`, this.userData.user_id, this.getConfig())
        this.fosas = Array.isArray(data) ? data : []
        localStorage.setItem('UserFosas', JSON.stringify(this.fosas))
      } catch (error) {
        console.error('Fosa accounts fetch error:', error)
      }
    },

    async GetNotifications() {
      try {
        const { data } = await axios.post(`${this.$apiUrl}GetNotifications`, this.userData.user_id, this.getConfig())
        this.notifications = Array.isArray(data) ? data : []
        this.latest_notfication = this.notifications[0] || {}
      } catch (error) {
        console.error('Notifications fetch error:', error)
      }
    },

    viewall() {
      this.showModal = true
    },
  },

  async created() {
    try {
      await Promise.all([
        this.getLoans(),
        this.getDeposit(),
        this.getShare(),        
        this.getFosaBal(),
        this.getFosaAccs(),
        this.GetNotifications(),
      ])
    } catch (error) {
      console.error('Dashboard initialization error:', error)
    }
  },
}
</script>

<style lang="scss">
  .row-separated {
    .flex + .flex {
      border-left: 1px solid #e3eaeb;
    }

    @include media-breakpoint-down(xs) {
      p:not(.display-2) {
        font-size: 0.875rem;
      }
    }
  }

  .dashboard {
    .va-card__header--over {
      @include media-breakpoint-up(md) {
        padding-top: 0 !important;
      }
    }
  }
</style>